import { NAME_SPACE as ns, ROOT_STATE_KEY as sk } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const SET_OPENED = `${ns}_${sk}_SET_OPENED`;
